import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MarketField, MarketInputPassword } from '@market/react';

const ControlledInputPassword = (props) => {
  const { t } = useTranslation();

  const {
    // fields used by Controller
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister = false,

    // fields used by Market
    disabled = false,
    label,
    placeholder,
    maxlength,
    minlength,
  } = props;

  // small hack because `required` doesn't doesn't do a whitespace check
  if (rules?.required) {
    rules.validate = (value) => Boolean(value.trim());
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { value, onChange },
        fieldState: { invalid, error },
        formState: { isSubmitting, isValidating },
      }) => (
        <MarketField
          {...((disabled || isSubmitting || isValidating) && {
            disabled: true,
          })}
          name={name}
          invalid={invalid}
        >
          <MarketInputPassword
            name={name}
            value={value}
            placeholder={placeholder}
            maxlength={maxlength}
            minlength={minlength}
            onMarketInputValueChange={(e) => onChange(e.detail.value)}
          >
            {label && <label>{label}</label>}
          </MarketInputPassword>
          <small slot="error">
            {error?.message || t('error.validation.invalidValue')}
          </small>
        </MarketField>
      )}
    />
  );
};

export default ControlledInputPassword;
